import { useState } from "react";
import { Button, Input, Select } from "../ui";
import { uploadInvoiceReceiptAPI } from "../../utils/api/billing";
import { formatSar } from "../../utils/billingMoney";

const ReceiptUploadModal = ({
  invoice,
  defaultAmountMinor,
  lang = "ar",
  text,
  onCancel,
  onUploaded,
}) => {
  const token = localStorage.getItem("auth-token");
  const customerText = text.customer;
  const methodOptions = [
    { value: "manual_bank_transfer", label: text.methods.manual_bank_transfer },
    { value: "cash", label: text.methods.cash },
    { value: "other", label: text.methods.other },
  ];
  const initialAmount =
    defaultAmountMinor != null
      ? (Number(defaultAmountMinor || 0) / 100).toFixed(2)
      : "";
  const [amount, setAmount] = useState(initialAmount);
  const [method, setMethod] = useState("manual_bank_transfer");
  const [reference, setReference] = useState("");
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async () => {
    if (loading) return;
    if (!amount || !file) {
      setError(customerText.amountAndReceiptRequired);
      return;
    }
    setLoading(true);
    setError("");
    try {
      await uploadInvoiceReceiptAPI(
        token,
        invoice._id,
        {
          amount,
          method,
          reference,
          idempotencyKey: `receipt-${invoice._id}-${Date.now()}`,
        },
        file,
      );
      await onUploaded();
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  return (
    <div className="billing-modal-backdrop">
      <div className="billing-modal">
        <h3>{customerText.uploadReceipt}</h3>
        <p>{customerText.uploadDescription}</p>
        {error && <div className="billing-error">{error}</div>}
        <div className="billing-plan-modal-form">
          {defaultAmountMinor != null && (
            <div className="billing-preview-box">
              <div>
                <span>{text.common.remaining}</span>
                <strong>{formatSar(defaultAmountMinor, lang)}</strong>
              </div>
            </div>
          )}
          <Input
            label={text.payments.amountSar}
            value={amount}
            onChange={(event) => setAmount(event.target.value)}
            placeholder="0.00"
          />
          <Select
            label={text.common.method}
            value={method}
            options={methodOptions}
            onChange={(event) => setMethod(event.target.value)}
          />
          <Input
            label={text.common.reference}
            value={reference}
            onChange={(event) => setReference(event.target.value)}
            placeholder={text.payments.transferReference}
          />
          <label className="billing-file-input">
            <span>{customerText.receiptFile}</span>
            <input
              type="file"
              accept=".pdf,.jpg,.jpeg,.png,.webp,application/pdf,image/jpeg,image/png,image/webp"
              onChange={(event) => setFile(event.target.files?.[0] || null)}
            />
          </label>
          <div className="billing-modal-actions">
            <Button
              appearance="filled"
              loading={loading}
              disabled={loading}
              onClick={submit}
            >
              {customerText.submitForReview}
            </Button>
            <Button appearance="ghost" disabled={loading} onClick={onCancel}>
              {text.common.cancel}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReceiptUploadModal;
